module.exports = __webpack_public_path__ + "img/top_icon.a4e54c1d.svg";